import { Injectable } from '@angular/core';
import { HttpClient, HttpParams,HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { SharedService } from "./../shared/shared.service";
import { ActionStatus } from "./action-status";


@Injectable()
export class ActionStatusService {

  constructor(private _http: HttpClient,
  private sharedService:SharedService) { }

  ServiceUrl: string = SharedService.BaseServiceUrl + "ActionStatus";

  // For Admin Authentication
  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': 'Basic ' + this.sharedService.getAdminTokenAtLocStorage()
    })
  };

  public getAll(): Observable<any[]> {
    let url = this.ServiceUrl + "/GetActionList";
    return this._http.get<any[]>(url,this.httpOptions);
  }

  public save(actionStatus: ActionStatus): Observable<string> {
    return this._http.post<string>(this.ServiceUrl, actionStatus)
  }

  public DevoteeProfileVarified(mobileNo: string): Observable<boolean> {
    let customUrl = this.ServiceUrl + "/DevoteeProfileVarified/" + mobileNo;
    return this._http.get<boolean>(customUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/action-status.service.ts